<template>

    <div class="lw-course-contents-chapter lw-padding-normal lw-bb-1px-fadeout90" @click="wrapperClicked" :class="sectionWrapperClass">

        <div class="mb-neg2_5rem learnworlds-main-text learnworlds-main-text-very-large lw-text-color-fadeout80 learnworlds-element">
            {{sectionNumber}}
        </div>

        <div class="with-flexible-parts align-items-center justify-content-space-between">
            <div class="with-flexible-parts align-items-center">
                <h3 class="learnworlds-heading3 learnworlds-heading3-normal learnworlds-element lw-course-contents-chapter-name no-margin-bottom">{{sectionTitle}}</h3>
                <div class="ml-10px lw-tag no-margin-bottom lw-brand-bg learnworlds-main-text learnworlds-element learnworlds-main-text-tiny" v-if="displayAccessLabel && sectionAccess !== 'premium'" >{{sectionDisplayedAccessLabel}}</div>

                <!-- drip feed -->
                <div class="ml-20px with-flexible-parts align-items-center" v-if="dripFeedTagsDisplay">
                    <span class="mr-10px small learnworlds-icon no-margin-bottom fas fa-lock"></span>
                    <div class="lw-tag no-margin-bottom lw-brand-bg learnworlds-main-text learnworlds-element learnworlds-main-text-tiny">{{sectionDripDateLabel}}</div>
                </div>
                <!----->

            </div>
            <span class="ml-10px learnworlds-icon large accordion-icon no-margin-bottom lw-text-color-fadeout80 fas" :class="arrowClass"></span>
        </div>

        <div v-if="sectionDescription" class="mt-10 no-margin-bottom learnworlds-main-text-normal">{{ sectionDescription }}</div>

        <div class="lw-course-contents-units mt-3rem" v-show="sectionDisplay">
            <div class="with-flexible-parts align-items-center lw-course-contents-unit p-8px-0" v-for="unit,index in sectionUnits" @click="unitClicked(unit,...arguments)">
                <span class="mr-10px no-margin-bottom learnworlds-main-text-normal learnworlds-icon fas fa-check-circle" v-if="unitCompleted(unit)"></span>

                <unit-icon class="lw-contents-svg normal" :icon="unit.icon"></unit-icon>

                <div class="ml-10px no-margin-bottom learnworlds-main-text learnworlds-main-text-normal learnworlds-element">
                    {{unit.title}}
                </div>
                <div class="hide-sp ml-10px no-margin-bottom lw-text-color-fadeout50 learnworlds-main-text learnworlds-main-text-normal learnworlds-element" v-if="getFullUnitData(unit) && getUnitExtraInfo(unit)">
                    {{getUnitExtraInfo(unit)}}
                </div>
                <span class="ml-10px no-margin-bottom learnworlds-main-text-normal learnworlds-icon fas fa-paperclip" v-if="unit.attachments && unit.attachments.length"></span>
            </div>
        </div>

    </div>
</template>

<script>
    import CourseContentsTemplateMixin from "../../mixins/CourseContentsTemplateMixin";
    import ComponentTemplatesMixin from "../../mixins/ComponentTemplatesMixin";

    export default {
        name: "CourseContentsTemplate3",
        mixins: [CourseContentsTemplateMixin,ComponentTemplatesMixin],
        props: {
            sectionsDisplay: {
                type: Object
            }
        },
        computed: {
            arrowClass () {
                return {
                    "fa-angle-down" : !this.sectionDisplay,
                    "fa-angle-up" : this.sectionDisplay,
                }
            },
            sectionDisplay () {
                return this.sectionsDisplay && this.sectionsDisplay[this.sectionData.titleId] ? true : false;
            }
        },
        methods: {
            wrapperClicked () {
                this.sectionClicked();
                this.emitAction('set-section-display' , !this.sectionDisplay);
            }
        }
    }
</script>

